import {CHANGE} from '@megaphonenpm/mputils/src/constants.js';
import {notEmpty, notNil} from '@megaphonenpm/mputils/src/utils.js';
import {STATE_SCENE} from './constants.js';
import {get} from 'lodash-es';
import {RankingsRecordMonitor} from './RankingsRecordMonitor.js';

/**
 * In non-MRTS scenes, RankingsAppStateSynchronizer keeps the AppState up to date with non-MRTS data
 * loaded from the appropriate external service.
 */
export class RankingsAppStateSynchronizer {
  constructor (appState, dataStore) {
    this.appState = appState;
    this.dataStore = dataStore;
    this.monitor = new RankingsRecordMonitor(null, dataStore);

    this.registerForAppStateChanges();
    this.registerForRankingsRecordMonitorChanges();
  }

  registerForAppStateChanges () {
    this.appState.on(CHANGE, e => {
      // At the start of each scene, if the scene's product is 'webpoll', then update
      // appState's 'votes' property to the most recently retrieved poll_results for the scene's
      // web poll.
      if (e.detail.prop === 'state') {
        this.monitor.stop();

        if (e.detail.value === STATE_SCENE) {
          if (this.appState.isCurrentSceneExternalScoreboard()) {
            // Set appState properties without dispatching CHANGE (quiet = true) because the current
            // appState.state assignment will trigger a single, central CHANGE event that views
            // handle and render. Setting the properties quietly prevents redundant rendering.
            // If any appState properties, such as .sceneRankings change AFTER this state change,
            // then those assignments should dispatch CHANGE (quiet = false).
            this.syncCurrentExternalRankings(true);

            this.monitor.setRankingsInfo(this.appState.getCurrentSceneSrcID());

            // Begin monitoring the web poll for changes
            this.monitor.start();

            if (!this.dataStore.rankings.has(this.appState.getCurrentSceneSrcID())) {
              // The dataStore does not contain the rankings record for this scene, so update the
              // rankings immediately by calling the WebPollMonitor instances's doTask() method.
              // (This case occurs when the client joins the MRTS run during a rankings scene from
              // a previous playlist, AFTER the current playlist has changed. If the new playlist
              // does not contain the rankings, the dataStore will not contain the rankings record.)
              this.monitor.doTask();
            }
          }
        }
      }
    });
  }

  registerForRankingsRecordMonitorChanges () {
    this.monitor.on(CHANGE, (e) => {
      this.syncCurrentExternalRankings();
    });
  }

  /**
   * Updates the appState to reflect the externally loaded rankings for the current scene.
   */
  syncCurrentExternalRankings (quiet = false) {
    let currentSceneSrcID = this.appState.getCurrentSceneSrcID();

    if (notEmpty(currentSceneSrcID)) {
      let rankingsArray = get(this.dataStore.rankings.get(currentSceneSrcID), 'data');
      if (notNil(rankingsArray)) {
        this.appState.setNonMRTSSceneRankings(rankingsArray, quiet);
      }
    }
  }
}


